import { Inbox } from "lucide-react";

export function EmptyState({ title, description }) {
  return (
    <div className="flex min-h-[150px] flex-col items-center justify-center rounded-md border border-dashed border-gray-300 px-4 py-8 text-center">
      <Inbox className="mb-3 text-gray-400" size={28} aria-hidden="true" />
      <p className="font-semibold text-gray-700">{title}</p>
      {description && <p className="mt-1 max-w-xl text-sm text-gray-500">{description}</p>}
    </div>
  );
}
